import { StaticImage } from "gatsby-plugin-image"
import React, { useEffect } from "react"
import { useState } from "react"
import StrapiMedia from "../strapi-media"

/* eslint-disable */
const Venues = ({ htmlTitle, images }) => {
  // eslint-disable-next-line
  const [imagesRender, setImagesRender] = useState(images.data.slice(0, 4))
  const [indexImageRender, setIndexImageRender] = useState(0)
  const [quantityImageRender, setQuantityImageRender] = useState(2)

  useEffect(() => {
    const handleImage = () => {
      if (window.matchMedia("(min-width:640px)").matches) {
        setIndexImageRender(0)
        setQuantityImageRender(2)
      } else setQuantityImageRender(1)
    }
    handleImage()
    window.addEventListener("resize", handleImage)
    return () => window.addEventListener("resize", handleImage)
  }, [])

  const goNext = () => {
    if (indexImageRender >= imagesRender.length - quantityImageRender)
      setIndexImageRender(0)
    else setIndexImageRender(indexImageRender + quantityImageRender)
  }

  const goPrev = () => {
    if (indexImageRender <= 0)
      setIndexImageRender(imagesRender.length - quantityImageRender)
    else setIndexImageRender(indexImageRender - quantityImageRender)
  }

  return (
    <div className="max-w-screen-reds-2xl w-full mx-auto mt-10 px-7">
      <div dangerouslySetInnerHTML={{ __html: htmlTitle }}></div>
      <div className="relative">
        <div className="lg:hidden absolute top-1/2 w-full">
          <div className="absolute left-[-25px] sm:left-[-5px] z-10 cursor-pointer">
            <div className="inline-block" onClick={() => goPrev()}>
              <StaticImage
                src="../../static/images/icon/angle-arrow-left.svg"
                alt="arrow"
              />
            </div>
          </div>
          <div className="absolute right-[-25px] sm:right-[-5px] z-10 cursor-pointer">
            <div className="inline-block" onClick={() => goNext()}>
              <StaticImage
                src="../../static/images/icon/angle-arrow-right.svg"
                alt="arrow"
              />
            </div>
          </div>
        </div>

        <div className="hidden lg:flex justify-center mt-20 items-center">
          {imagesRender.map((image, index) => {
            return (
              <div key={`image-venue-${index}`}>
                <StrapiMedia image={{ data: image }} width={260} />
              </div>
            )
          })}
        </div>
        <div className="hidden sm:flex lg:hidden justify-center mt-20 items-center">
          <StrapiMedia
            image={{ data: imagesRender[indexImageRender] }}
            width={280}
          />
          <StrapiMedia
            image={{ data: imagesRender[indexImageRender + 1] }}
            width={280}
          />
        </div>
        <div className="flex sm:hidden justify-center mt-20 items-center">
          <StrapiMedia
            image={{ data: imagesRender[indexImageRender] }}
            width={280}
          />
        </div>
      </div>
      <div className="m-auto mt-20">
        <div className="w-full border-b"></div>
      </div>
    </div>
  )
}

export default Venues
